module.exports = __webpack_public_path__ + "img/dots_rdp_4.370276ba.png";